module.exports = __webpack_public_path__ + "static/img/brees-2011-slide-6.665d238.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2011-slide-6.jpg
// module id = LQVc
// module chunks = 1